export const CURRENCY = {
    TENGE: "₸",
    EURO: "€",
    BELARUSIAN_RUBLE: "Br",
    RUSSIAN_RUBLE: "₽"
};